import React from "react";
import {
    Header, Segment, Button, Search, Checkbox, Label, Form, Modal
} from 'semantic-ui-react';
import Loader from "../../../sharedComponent/loader/loader";
import NoResultFound from "../../../sharedComponent/noResultFound"
import { Constants } from "../../../../config/appConstants";

const CreateTaskGroupComponent = props => {

    return (
        <Segment.Group>
            <Segment className="stickyHeader">
                <Header as="h3" size='medium' textAlign='center'>{Constants.HEADING_FAVORITE_TASK_CODE_GROUPS}</Header>
            </Segment>

            <Segment className="pb-5">
                <Form className="pb-2 root">
                    <Form.Input className='padding m-0 groupName'
                        fluid placeholder={Constants.PLACEHOLDER_ENTER_FAVORITES_NAME} value={props.createTaskGroup.grpName} onChange={props.handleChangeGrpName} />
                    <div className="overflowScroll accordionMenuHeight">

                        {/* {props.createTaskGroup.alreadySelectedTasks && props.createTaskGroup.alreadySelectedTasks.filter(e => props.createTaskGroup.selectedTaskList.includes(Number(e.taskCodeID))).map((task) => (
                            <Checkbox className="selectedRow empGroupSelected w-100" value={Number(task.taskCodeID)} label={`${task.taskNumber} - ${task.taskName}`}
                                onChange={props.onTaskSelect}
                                checked={props.createTaskGroup.selectedTaskList.includes(Number(task.taskCodeID))}
                            />
                        ))} */}
                        {props.createTaskGroup.selectedTasks && props.createTaskGroup.selectedTasks.map((task) => (
                          // !props.createTaskGroup.alreadySelectedTasks.find(at=> Number(at.taskCodeID) === task.id) &&
                           <Checkbox className="selectedRow empGroupSelected w-100" value={task.id} label={`${task.taskNumber} - ${task.taskName}`}
                               // onChange={props.onTaskSelect}
                               // checked={props.createTaskGroup.selectedTaskList.includes(task.id)}
                               checked
                            />
                        ))}
                    </div>
                    <Label color='orange' className='padding w-100 m-0 borderRadiusNone'>Others</Label>
                    <Search className='padding' onSearchChange={props.onSearch} value={props.createTaskGroup.searchText} placeholder="Search Task Codes" />
                    <div className="mainContentRoot">

                        {props.createTaskGroup.allTaskList && props.createTaskGroup.allTaskList.map((task) => (
                            <Checkbox className="selectedRow empGroupSelected w-100" value={task.id} label={`${task.taskNumber} - ${task.taskName}`}
                                onChange={(e,value) => props.onTaskSelect(task.id,task.taskNumber,task.taskName,value)}
                                checked={props.createTaskGroup.selectedTaskList.some(t => t.taskName === task.taskName && t.taskNumber === task.taskNumber)}
                                
                            />
                        ))}

                        {(!props.createTaskGroup.allTaskList || props.createTaskGroup.allTaskList.length === 0) &&
                           <NoResultFound displayMessage={Constants.NO_TASKS_FOUND} />
                         } 

                    </div>
                </Form>
            </Segment>
            <Segment>
                <div className='d-flex align-items justify-content-between btnFooter'>
                    <Button secondary onClick={props.onClickBack} className="borderRadius w-10" size='small'>
                        Back</Button>
                    {props.createTaskGroup.groupId > 0 &&
                        <Button secondary onClick={props.onClickDelete} className="borderRadius w-20" size='small'>
                            {Constants.DELETE_FAVORITES} </Button>
                    }
                    <Button secondary className="borderRadius w-10" size='small' onClick={props.onClickSave}>
                        Save</Button>
                </div>
            </Segment>

            {/* Confirmation popup */}
            <Modal
                open={props.createTaskGroup.isShowSaveConfirmation}
                closeOnDimmerClick={false}
                size='tiny'
            >
                <Modal.Header className="text-center">Confirmation</Modal.Header>
                <Modal.Content >
                    Do you want to save changes?
                </Modal.Content>
                <Modal.Actions className="d-flex justify-content-between">
                    <Button secondary className="borderRadius w-25 ml-0" size='small' onClick={props.onCloseModel}>
                        No
                    </Button>
                    <Button secondary className="borderRadius w-25 mr-0" size='small' onClick={props.onClickSave}>
                        Yes
                    </Button>
                </Modal.Actions>
                {props.createTaskGroup.isShowLoader &&
                    <Loader />
                }
            </Modal>

            {/* Delete Timecard Popup */}
            {props.createTaskGroup.isDeleteConfirmationPopupVisible &&
                <Modal
                    open={props.createTaskGroup.isDeleteConfirmationPopupVisible}
                    closeOnDimmerClick={false}
                    size='tiny'
                >
                    <Modal.Header className="text-center">{Constants.DELETE_FAVORITES}</Modal.Header>
                    <Modal.Content scrolling style={{ minHeight: "auto" }}>
                        <p>{Constants.CONFIRMATION_TASK_DELETED_MESSAGE}</p>
                    </Modal.Content>
                    <Modal.Actions  className="d-flex justify-content-between" >
                        <Button className="borderRadius w-15" size='small' secondary onClick={props.onCancelClickInConfirmationPopup}>
                            Cancel
                        </Button>
                        <Button className="borderRadius w-15" size='small' secondary onClick={props.onDeleteClickInConfirmationPopup}>
                            Delete
                        </Button>
                    </Modal.Actions>
                    {props.createTaskGroup.isShowLoader &&
                        <Loader />
                    }
                </Modal>
            }

            {props.createTaskGroup.isShowLoader &&
                <Loader />
            }
        </Segment.Group>
    );
}

export default CreateTaskGroupComponent;

CreateTaskGroupComponent.displayName = "CreateTaskGroupComponent";